import { QSET_LIST_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { useExaminationCourse } from '@exam-management/examination-course-details';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QSetReviewTaskCreationButton,
  QSetReviewTaskCreationFormProvider,
  QSetReviewTaskCreationProvider,
} from '@exam-management/qset-review-task-creation';
import {
  AddRoundedIcon,
  AssignmentOutlinedIcon,
  Divider,
  Flex,
  PaperSection,
} from '@shared/components';
import { WithPermission } from '@shared/permissions';

import { QSetListModalProvider } from '../../providers';
import { GenerateQSetButton } from '../generate-qset-button';
import { QSetList } from '../qset-list';
import { QSetListNavigationTabs } from '../qset-list-navigation-tabs';

export default function QSetListPaperSection() {
  const { examinationCourse } = useExaminationCourse();
  return (
    <QSetReviewTaskCreationProvider>
      <QSetReviewTaskCreationFormProvider>
        <QSetListModalProvider>
          <PaperSection
            title='QSet'
            endAdornment={
              <Flex sx={{ gap: (theme) => theme.spacing(3) }}>
                <WithPermission
                  requiredPermission={[
                    APP_PERMISSIONS.TASK.QSET_REVIEW.CREATE,
                    APP_PERMISSIONS.EXAM.EXAMINATION_COURSE.VIEW,
                    APP_PERMISSIONS.EXAM.QSET.VIEW,
                    APP_PERMISSIONS.SETTING.USER.VIEW,
                  ]}
                >
                  <QSetReviewTaskCreationButton
                    startIcon={<AssignmentOutlinedIcon />}
                    examCourse={{ value: examinationCourse.id, label: examinationCourse.name }}
                    variant='outlined'
                    color='secondary'
                    sx={{ flexGrow: 1 }}
                    data-testid={QSET_LIST_DATA_TEST_ID.CREATE_REVIEW_TASK_BUTTON}
                  >
                    Create Review Task
                  </QSetReviewTaskCreationButton>
                </WithPermission>
                <GenerateQSetButton
                  data-testid={QSET_LIST_DATA_TEST_ID.GENERATE_QSET_BUTTON}
                  startIcon={<AddRoundedIcon />}
                >
                  Generate QSet
                </GenerateQSetButton>
              </Flex>
            }
            sx={{
              flex: 1,
            }}
          >
            <Flex
              sx={(theme) => ({
                m: theme.spacing(6),
                borderRadius: theme.shape.rounded(2),
                border: '1px solid',
                borderColor: theme.palette.grey[200],
                flexDirection: 'column',
                overflow: 'hidden',
                flexGrow: 1,
              })}
            >
              <QSetListNavigationTabs />
              <Divider
                sx={{
                  mt: '-1px',
                }}
              />
              <QSetList />
            </Flex>
          </PaperSection>
        </QSetListModalProvider>
      </QSetReviewTaskCreationFormProvider>
    </QSetReviewTaskCreationProvider>
  );
}
